"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageImageGalleryModuleLayouts = void 0;
exports.SetPageImageGalleryModuleLayouts = [
    "image-links",
    "card-swiper",
    "grid",
    "carousel",
];
//# sourceMappingURL=ImageGallery.js.map